import { useTranslation } from 'react-i18next';
import { FormControl } from '@material-ui/core';
import { FieldArray } from 'redux-form';
import { requiredArray } from '../../../util/validators';
import React from 'react';
import {
  DynamicComponentInput,
  DynamicFormFieldArray,
  renderDynamicComponent,
  REPLACE_INDEX,
} from './DynamicComponent';
import { FieldNames } from '../../../models/fields/names';
import { DynamicFormFieldArrayType } from '../../../models/options/enums';
import { creditCardsInitialValue } from '../../../util/initial-values';

const creditCardInputs: DynamicComponentInput[] = [
  {
    fieldName  : FieldNames.financialStatementCreditor,
    isOptional : false,
    label      : 'Creditor',
    type       : DynamicFormFieldArrayType.TEXT_INPUT,
  },
  {
    fieldName       : FieldNames.financialStatementCurrentBalance,
    isOptional      : false,
    label           : 'Current Balance',
    type            : DynamicFormFieldArrayType.CURRENCY_ALLOW_ZERO,
    validator  : {
      param : `${FieldNames.financialStatementCreditCards}-${REPLACE_INDEX}-${FieldNames.financialStatementMonthlyPayment}`,
      type  : 'isGreaterThanFieldDynamicComponent',
    },
  },
  {
    fieldName  : FieldNames.financialStatementMonthlyPayment,
    isOptional : false,
    label      : 'Monthly Payment',
    type       : DynamicFormFieldArrayType.CURRENCY_ALLOW_ZERO,
  },
  {
    fieldName  : FieldNames.financialStatementJointAccount,
    isOptional : false,
    label      : 'Is this held jointly',
    type       : DynamicFormFieldArrayType.Y_N_SWITCH_TOGGLE,
  },
];

const creditCardProps: DynamicFormFieldArray = {
  addButtonText : 'Account',
  initialValue  : creditCardsInitialValue,
  inputs        : creditCardInputs,
};

export const CreditCardsFFAComponent = ({ ...props }) => {
  const { name, options } = props;
  const { t }    = useTranslation();

  return (
    <FormControl fullWidth>
      <FieldArray
        component = {renderDynamicComponent}
        name      = { name }
        props     = { { dynamicProps: creditCardProps, name, t, options } }
        validate  = {[
          requiredArray([]),
        ]}
      />
    </FormControl>
  );
};
